import { render } from "./PhotosList.vue?vue&type=template&id=385db4b0&scoped=true"
import script from "./PhotosList.vue?vue&type=script&lang=js"
export * from "./PhotosList.vue?vue&type=script&lang=js"

import "./PhotosList.vue?vue&type=style&index=0&id=385db4b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385db4b0"]])

export default __exports__